import { useCallback, useMemo } from 'react'

export function useConnectingSound() {
  const audio = useMemo(() => {
    if (typeof window !== 'undefined' && typeof Audio !== 'undefined') {
      return new Audio('/sounds/join.mp3')
    }

    return undefined
  }, [])

  const play = useCallback(() => {
    audio?.play()
  }, [audio])

  return { play }
}
